import styled from 'styled-components';

const PADDING = '24px';

const StyledSubscriptionsPage = styled.div`
  padding: ${PADDING};
  min-height: calc(100vh - 64px - (${PADDING} * 2));
`;

export {
  StyledSubscriptionsPage
}
